import { HashRouter, Routes, Route } from "react-router-dom";
import "leaflet/dist/leaflet.css";
import "./App.css"
import { useEffect } from "react";
import Home from "./Home";
import AdminStallBooking from './AdminStallBooking';
import Booking_event from "./Booking_event";
import AboutUs from "./AboutUs";
import ContactUs from "./ContactUs";
import AdminDashBoard from "./AdminDashBoard";
import EventPage from "./EventPage";
import AddEvent from "./AddEvent";
import Event_calander from "./Event_calander";
import EventCard from "./EventCard";
import { useState } from "react";
import Ticket_Booking from "./Ticket_Booking";
import AdminLayoutBuilder from "./AdminLayoutBuilder";
import WebPageEditor from "./WebPageEditor";
import Services from "./Services";
import BookingServices from "./BookingServices";
import UpcomingEvents from './UpcomingEvents';
import 'aos/dist/aos.css';
import AOS from 'aos';
import RoyalDinners from "./RoyalDinners";
import MusicAndConcerts from "./MusicAndConcerts";
import RoyalHeritageFestia from "./RoyalHeritageFestia";
import StallCancellation from "./StallCancellatioin";
import { ContentProvider } from "./ContentContext";  // Import ContentProvider
import PrivacyPolicy from './PrivacyPolicy';
import TermsOfUse from './TermsOfUse';
import RefundPolicy from './RefundPolicy';
function App() {
  const [eventDetails, setEventDetails] = useState([]);
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
      offset: 100,
      easing: 'ease-out-cubic'
    });
  }, []);

  return (
    <ContentProvider>  {/* Wrap with ContentProvider */}
      <HashRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/Booking_event" element={<Booking_event />} />
          <Route path="/Aboutus" element={<AboutUs />} />
          <Route path="/ContactUs" element={<ContactUs />} />
          <Route path="/adminDashBoard" element={<AdminDashBoard />} />
          <Route path="/addevent" element={<AddEvent setEventDetails={setEventDetails} />} />
          <Route path="/eventcalander" element={<EventPage eventDetails={eventDetails} />} />
          <Route path="/eventCard" element={<EventCard />} />
          <Route path="/eventcalander_2" element={<Event_calander />} />
          <Route path="/BookingTicket" element={<Ticket_Booking />} />
          <Route path="/admin/layout-builder" element={<AdminLayoutBuilder />} />
          <Route path="/webpage-editor/:pageName" element={<WebPageEditor />} />
          <Route path="/webpage-editor" element={<WebPageEditor />} />
          <Route path="/Services" element={<Services />} />
          <Route path="/bookingservices" element={<BookingServices />} />
          <Route path="/admin/stall-booking" element={<AdminStallBooking />} />
          <Route path="/upcoming-events" element={<UpcomingEvents />} />
          <Route path="/RoyalDinners" element={<RoyalDinners />} />
          <Route path="/MusicAndConcerts" element={<MusicAndConcerts />} />
          <Route path="/RoyalHeritageFiesta" element={<RoyalHeritageFestia />} />
          <Route path="/Stall-cancellation" element={<StallCancellation />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
  <Route path="/terms" element={<TermsOfUse />} />
  <Route path="/refund" element={<RefundPolicy />} />
        </Routes>
      </HashRouter>
    </ContentProvider>
  );
}

export default App;